import React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import HeaderImage from "../../assets/AboutUs/header-image.jpg";

const SliderImage = () => {
  return (
    <Box
      id="image"
      sx={{
        position: "relative",
        height: { xs: 400, sm: 400 },
        width: "100%",
        backgroundImage: `url(${HeaderImage})`,
        backgroundSize: "cover",
        borderRadius: "5px",
        //   outline: "1px solid",
      }}
    >
      <Typography
        variant="h4"
        sx={{
          position: "absolute",
          bottom: "24%",
          left: "5%",
          padding: "16px",
          color: "white",
          // borderBottomLeftRadius: "10px",
          // borderBottomRightRadius: "10px",
          fontSize: { xs: "1.5rem", sm: "2rem" },
        }}
      >
        <span> Create a better tomorrow today</span>
        <p style={{ fontSize: "0.7em" }}>
          Integrated technical system of on-site technical service and
          evaluation of oil stabilization and water control effect
        </p>
      </Typography>
    </Box>
  );
};

export default SliderImage;
